module.exports = __webpack_public_path__ + "images/832d0cb9ddaac6a0288af0460d9b38e1-family_xpo.png";